module.exports = __webpack_public_path__ + "static/img/person-selected.6cb9c253.svg";